// AUTO-GENERATED by scripts/generateGamesManifest.js — DO NOT EDIT
/* eslint-disable */
// prettier-ignore

// Game image imports
import img_145 from "../../images/game/699c4e0d487902dd93c9c77d.png";
import img_146 from "../../images/game/solitaireguru.png";
import img_147 from "../../images/game/wowguru.png";
import img_148 from "../../images/game/wow.png";
import img_149 from "../../images/game/wowsearch.png";
import img_150 from "../../images/game/colorbump3d.png";
import img_151 from "../../images/game/hunter-assassin-2.png";
import img_152 from "../../images/game/endcard.png";
import img_153 from "../../images/game/atlasgame.png";
import img_154 from "../../images/game/word-letter.png";
import img_155 from "../../images/game/balls-master.png";
import img_156 from "../../images/game/ball-blast.png";
import img_157 from "../../images/game/tap-on-time.png";
import img_158 from "../../images/game/game-of-words.png";
import img_159 from "../../images/game/name-the-activity.png";
import img_160 from "../../images/game/mad-smash.png";
import img_161 from "../../images/game/wordSquare.png";
import img_162 from "../../images/game/video-game-html.png";
import img_163 from "../../images/game/atlas-game-html.png";
import img_164 from "../../images/game/crossword-playable.png";
import img_165 from "../../images/game/crossword-jam.png";
import img_166 from "../../images/game/wordsquare-playsimple.png";
import img_167 from "../../images/game/word-wars.png";
import img_168 from "../../images/game/anagram.png";
import img_169 from "../../images/game/alien_shooter.jpg";
import img_170 from "../../images/game/sunday-solitaire.png";
import img_171 from "../../images/game/word-surf.png";
import img_172 from "../../images/game/word-search-ps.png";
import img_173 from "../../images/game/scratch-html.png";
import img_174 from "../../images/game/wizard-hero.png";
import img_175 from "../../images/game/differences.png";
import img_176 from "../../images/game/tile-match-ps.png";
import img_177 from "../../images/game/2248-tiles-ps.jpeg";
import img_178 from "../../images/game/bloxie_base1.png";
import img_179 from "../../images/game/block-buster.jpg";
import img_180 from "../../images/game/endCard-html.png";
import img_181 from "../../images/game/find-hidden-objects.png";
import img_182 from "../../images/game/hidden-tiles.png";
import img_183 from "../../images/game/word-roll.png";
import img_184 from "../../images/game/jigsaw.png";
import img_185 from "../../images/game/html5-ps.png";
import img_186 from "../../images/game/cwd-search.png";
import img_187 from "../../images/game/e_com.png";
import img_188 from "../../images/game/match-three-rocks.png";
import img_189 from "../../images/game/wordhane.png";
import img_190 from "../../images/game/sort-out.png";
import img_191 from "../../images/game/fighter-merge.png";
import img_192 from "../../images/game/cryptogram_ps.png";
import img_193 from "../../images/game/tacticus-3d-base-1.png";
import img_194 from "../../images/game/top-drives.png";
import img_195 from "../../images/game/word-search-solitaire-ps.png";
import img_196 from "../../images/game/f-1-clash.png";
import img_197 from "../../images/game/crossword-go.jpg";
import img_198 from "../../images/game/wonder-blast.png";
import img_199 from "../../images/game/heroes-of-history-base-1.png";
import img_200 from "../../images/game/bloom-city-match-main.png";
import img_201 from "../../images/game/video-game-html-ps.png";
import img_202 from "../../images/game/matchcreek-change-parts.png";
import img_203 from "../../images/game/bloons-td-3d-base-1.png";
import img_204 from "../../images/game/word-master.png";
import img_205 from "../../images/game/family-feud-base-1.png";
import img_206 from "../../images/game/word-connect.png";
import img_207 from "../../images/game/town-match.png";
import img_208 from "../../images/game/match-squad-core-gameplay.png";
import img_209 from "../../images/game/jigsaw-selection.png";
import img_210 from "../../images/game/jig-picture.png";
import img_211 from "../../images/game/nice-cream.png";
import img_212 from "../../images/game/jigsolitaire-ps.png";
import img_213 from "../../images/game/cross-numbers.jpg";
import img_214 from "../../images/game/word-mosaic.png";
import img_215 from "../../images/game/sudoku-ps.png";
import img_216 from "../../images/game/three-js-template.png";
import img_217 from "../../images/game/hexa-tap-away.png";
import img_218 from "../../images/game/make-it-wonder.png";
import img_219 from "../../images/game/search-it.png";
import img_220 from "../../images/game/bubble-drop.png";
import img_221 from "../../images/game/empires-and-puzzles-core-gameplay.png";

// Default game config imports
import { defaultGameConfig as config_0 } from "../../../games/game-5f5b691eb75dc0c7b89b2492/base-5f5b691eb75dc0c7b89b2493/node_modules/@games/solitaireguru/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_1 } from "../../../games/game-601a6443b3e245291110ac7a/base-601a649cb3e245291110acce/node_modules/@games/wowguru/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_2 } from "../../../games/game-601a6443b3e245291110ac7a/base-6103eaf12eae9d3e856d6ec8/node_modules/@games/wowgurubase2/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_3 } from "../../../games/game-601a6443b3e245291110ac7a/base-615df9f441e1e0829ab60118/node_modules/@games/wowgurubase3/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_4 } from "../../../games/game-601a6443b3e245291110ac7a/base-6397080fa16dbba4ba8df419/node_modules/@games/wowgurubase4/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_5 } from "../../../games/game-601a6443b3e245291110ac7a/base-63970bb3a16dbba4ba8df48a/node_modules/@games/wowgurubase5/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_6 } from "../../../games/game-601a6443b3e245291110ac7a/base-6613bbb840aceaef5d8ca8fd/node_modules/@games/crossword-jam-fugo/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_7 } from "../../../games/game-601a6443b3e245291110ac7a/base-69d4b08d035de1478c5313a6/node_modules/@games/wow-guru-cj-top/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_8 } from "../../../games/game-603ce43ea91fee82f50334d3/base-603ce698a91fee82f50336fe/node_modules/@games/wow/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_9 } from "../../../games/game-603ce43ea91fee82f50334d3/base-650d4cfef1e29aa6e06d261f/node_modules/@games/wowBase2/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_10 } from "../../../games/game-603ce43ea91fee82f50334d3/base-651a6d1f1bc1b828d545667b/node_modules/@games/wowBase3/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_11 } from "../../../games/game-603ce43ea91fee82f50334d3/base-6530e2601904b92b4fbe379d/node_modules/@games/wowBase4/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_12 } from "../../../games/game-603ce43ea91fee82f50334d3/base-653777541904b92b4fbec721/node_modules/@games/wowBase5/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_13 } from "../../../games/game-603ce43ea91fee82f50334d3/base-664df9c5bb75a0017c85a6aa/node_modules/@games/grammar-game/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_14 } from "../../../games/game-603ce43ea91fee82f50334d3/base-6777f21d92e99634ba954119/node_modules/@games/wow-spelling-bee/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_15 } from "../../../games/game-603ce43ea91fee82f50334d3/base-67a103fb16f552e843a45d87/node_modules/@games/wow100dAutoplaySIP/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_16 } from "../../../games/game-603ce43ea91fee82f50334d3/base-67b59c4916f552e843a82179/node_modules/@games/quiz-wtw/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_17 } from "../../../games/game-603ce43ea91fee82f50334d3/base-6818a35816f552e843b1fb97/node_modules/@games/wow-hintboard/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_18 } from "../../../games/game-603ce43ea91fee82f50334d3/base-688cb722b58a71fcc12a7ada/node_modules/@games/wowzen-hintboard/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_19 } from "../../../games/game-603ce43ea91fee82f50334d3/base-68a568a7b58a71fcc12cdcd6/node_modules/@games/wow-classic-phaser-3-80/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_20 } from "../../../games/game-603ce43ea91fee82f50334d3/base-68bec1dface07b66002a8ea4/node_modules/@games/wowzen-daily-mode/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_21 } from "../../../games/game-603ce43ea91fee82f50334d3/base-68c966eb2bf654ac1ba732c2/node_modules/@games/wow-cola-fast/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_22 } from "../../../games/game-603ce43ea91fee82f50334d3/base-68f205bff9752f622e2aaf62/node_modules/@games/wow-5-level-select/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_23 } from "../../../games/game-603ce43ea91fee82f50334d3/base-68f9f3f9ac586102dd22f713/node_modules/@games/wow-zen-3-word-hint/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_24 } from "../../../games/game-603ce43ea91fee82f50334d3/base-6916ddd43a547fddee788a46/node_modules/@games/wow-wheel-arrow-selection/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_25 } from "../../../games/game-603ce43ea91fee82f50334d3/base-691efc10f0ad3f159bc35c77/node_modules/@games/wow-name-city/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_26 } from "../../../games/game-603ce43ea91fee82f50334d3/base-6936ce56fc02f9d8109d2ae6/node_modules/@games/wow-b-hb/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_27 } from "../../../games/game-603ce43ea91fee82f50334d3/base-693ac4e55572221276ab43b8/node_modules/@games/wow-opponent/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_28 } from "../../../games/game-603ce43ea91fee82f50334d3/base-69dc56d014010a01d60b8a78/node_modules/@games/wow-100-d-new/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_29 } from "../../../games/game-603ce43ea91fee82f50334d3/base-6a2a5369da0eee2da0737d4b/node_modules/@games/wow-word-list-keyboard/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_30 } from "../../../games/game-603ce43ea91fee82f50334d3/base-6a3e8d87be78e15762bd6a64/node_modules/@games/wow-zen-crossword/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_31 } from "../../../games/game-605cc7b259a203d77244525c/base-605cc8a259a203d772445287/node_modules/@games/wowsearch/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_32 } from "../../../games/game-605cc7b259a203d77244525c/base-654b3d221904b92b4fbeeb53/node_modules/@games/wordsearchbase2/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_33 } from "../../../games/game-605cc7b259a203d77244525c/base-69a002cef372556bcdea313f/node_modules/@games/wow-zen-search/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_34 } from "../../../games/game-605cc7b259a203d77244525c/base-6a60c472c465a15559854f2d/node_modules/@games/wow-search-cola-fast/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_35 } from "../../../games/game-6079680d222d9801f96bab74/base-60796c54222d9801f96bac5b/node_modules/@games/colorbump3d/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_36 } from "../../../games/game-614081de93ddb73076a1538a/base-6140893d93ddb73076a1554e/node_modules/@games/hunter-assassin-2/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_37 } from "../../../games/game-619e14fb68af90fbc06a4345/base-619e14fb68af90fbc06a4345/node_modules/@apps/endcard/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_38 } from "../../../games/game-61af33d3222f4485886da806/base-61af33d3222f4485886da806/node_modules/@apps/atlasgame/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_39 } from "../../../games/game-61af33d3222f4485886da806/base-623c457358d6dd7853a01a00/node_modules/@apps/video-game/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_40 } from "../../../games/game-61fd1d864e862442e1bd67db/base-61fd1eb64e862442e1bd6828/node_modules/@games/word-letter/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_41 } from "../../../games/game-62581d4558d6dd7853a161e8/base-625984d758d6dd7853a1bd9d/node_modules/@games/balls-master/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_42 } from "../../../games/game-625e7d9c152625add904a679/base-625e7ecf152625add904a6d9/node_modules/@games/ball-blast/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_43 } from "../../../games/game-6266a66a152625add904bce8/base-6266a6fe152625add904bd19/node_modules/@games/tap-on-time/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_44 } from "../../../games/game-6267bb9ee12f014cd14b6c9f/base-6267c05ae12f014cd14b6eed/node_modules/@games/game-of-words/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_45 } from "../../../games/game-627baaf241f6066717ff413f/base-627babd141f6066717ff417d/node_modules/@games/name-the-activity/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_46 } from "../../../games/game-62864cd341f6066717ff801e/base-6286500f41f6066717ff80c7/node_modules/@games/mad-smash/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_47 } from "../../../games/game-629e01961f70c95b7fd67b3a/base-629e0b671f70c95b7fd67de8/node_modules/@games/wordsquare/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_48 } from "../../../games/game-629e01961f70c95b7fd67b3a/base-6450ec1566c580b614f8bb06/node_modules/@games/wordsquarebase2/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_49 } from "../../../games/game-629e01961f70c95b7fd67b3a/base-68adabd0b58a71fcc12e2192/node_modules/@games/wow-hexa-mahjong/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_50 } from "../../../games/game-629e01961f70c95b7fd67b3a/base-69b7b831238b6de497d7803e/node_modules/@games/wow-guru-hexa/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_51 } from "../../../games/game-62a09e2041f6066717fff686/base-62a0a15241f6066717fff6ee/node_modules/@apps/video-game-html/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_52 } from "../../../games/game-62b9a830cc0ad8e0a9eaa81c/base-62b9b2a2cc0ad8e0a9eaa9b7/node_modules/@apps/atlas-game-html/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_53 } from "../../../games/game-62e8c71357d6958461cbe9d6/base-62e8c9a757d6958461cbea45/node_modules/@games/crossword-playable/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_54 } from "../../../games/game-62f50cd857d6958461cc54d3/base-62f50da057d6958461cc550e/node_modules/@games/crossword-jam/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_55 } from "../../../games/game-62f50cd857d6958461cc54d3/base-6332e467d12f27f917df1ac0/node_modules/@games/cwdJam2/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_56 } from "../../../games/game-62f50cd857d6958461cc54d3/base-66b5fe200f1aafc87731fcb5/node_modules/@games/crossword-jam-base3/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_57 } from "../../../games/game-62f6121457d6958461cc7ef0/base-62f612be60e29e02961bbfd6/node_modules/@games/wordsquare-playsimple/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_58 } from "../../../games/game-6318807957d6958461cd5fc1/base-6318818257d6958461cd6005/node_modules/@games/word-wars/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_59 } from "../../../games/game-6318807957d6958461cd5fc1/base-6461dcd4f01fdda7a6d2769b/node_modules/@games/wordWarsBase2/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_60 } from "../../../games/game-632aca17d12f27f917de59ec/base-632acab6d12f27f917de5a16/node_modules/@games/anagram/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_61 } from "../../../games/game-635fe93ded1431b3f7d2215c/base-635fe9eaed1431b3f7d22181/node_modules/@games/alien_shooter/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_62 } from "../../../games/game-6371ed43dd2735639e05b6ab/base-637345bcdd2735639e05c8b0/node_modules/@games/sunday-solitaire/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_63 } from "../../../games/game-63f8a26aa2afbaeb5f803de3/base-63f8a309a2afbaeb5f803e1f/node_modules/@games/word-surf/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_64 } from "../../../games/game-63ff24d8f1b9d0fb8487223f/base-63ff2e7ff1b9d0fb84872367/node_modules/@games/word-search-ps/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_65 } from "../../../games/game-63ff24d8f1b9d0fb8487223f/base-6527bf7c1904b92b4fbd6721/node_modules/@games/wordsearchpsbase2/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_66 } from "../../../games/game-640060027d19caf1ca799d1f/base-64007d1f7d19caf1ca79a27b/node_modules/@games/scratch-html/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_67 } from "../../../games/game-649a7061f01fdda7a6d44598/base-649a90aaf01fdda7a6d44888/node_modules/@games/wizard-hero/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_68 } from "../../../games/game-656f16ee7e3091d6e2607a1d/base-6570216c7e3091d6e2607d91/node_modules/@games/differences/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_69 } from "../../../games/game-656f16ee7e3091d6e2607a1d/base-69ef52e55b3df618e76de9c9/node_modules/@games/find-differences-image-match/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_70 } from "../../../games/game-65a6576f99010ea68565fb77/base-65a6644b99010ea68565fd0e/node_modules/@games/tile-match-ps/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_71 } from "../../../games/game-65a6576f99010ea68565fb77/base-6879f875b58a71fcc127119f/node_modules/@games/tile-match-version-2/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_72 } from "../../../games/game-65cb16fc897ec6f9db711354/base-65cb1d1d897ec6f9db711418/node_modules/@games/2248-tiles-ps/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_73 } from "../../../games/game-65fae6d540aceaef5d88bd51/base-65fae73d40aceaef5d88bd70/node_modules/@games/bloxie_base1/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_74 } from "../../../games/game-661504b840aceaef5d8cba1f/base-6615052f40aceaef5d8cba51/node_modules/@games/block-buster/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_75 } from "../../../games/game-6615087940aceaef5d8cbace/base-6615094d40aceaef5d8cbafd/node_modules/@games/endCard-html/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_76 } from "../../../games/game-6627943e40aceaef5d8eec81/base-6627a1da40aceaef5d8eee0d/node_modules/@games/find-hidden-objects/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_77 } from "../../../games/game-6627943e40aceaef5d8eec81/base-68273d6016f552e843b5154c/node_modules/@games/find-hidden-object-base-2/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_78 } from "../../../games/game-6627943e40aceaef5d8eec81/base-6889febab58a71fcc129ac1c/node_modules/@games/find-hidden-object-two-level/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_79 } from "../../../games/game-6627943e40aceaef5d8eec81/base-68ef701d42950b539b7c40b5/node_modules/@games/find-hidden-object-two-level-base-2/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_80 } from "../../../games/game-6627943e40aceaef5d8eec81/base-694bcf96a600611cdb08c3a2/node_modules/@games/find-hidden-object-tapslide/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_81 } from "../../../games/game-6627943e40aceaef5d8eec81/base-699eb28720f540073a45a111/node_modules/@games/find-hidden-object-collect-objects/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_82 } from "../../../games/game-6627943e40aceaef5d8eec81/base-69afd3f598e86c1ebb1a8c75/node_modules/@games/find-hidden-object-panoramic-map/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_83 } from "../../../games/game-6627943e40aceaef5d8eec81/base-69e8affa3f5ac655e8557c36/node_modules/@games/find-hidden-object-6-level/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_84 } from "../../../games/game-66333f70937d97accbf169e1/base-66334529937d97accbf16a85/node_modules/@games/hidden-tiles/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_85 } from "../../../games/game-66333f70937d97accbf169e1/base-668e67310f1aafc87706b7d0/node_modules/@games/hiddenObjects/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_86 } from "../../../games/game-66333f70937d97accbf169e1/base-67f6eb9516f552e843af42cf/node_modules/@games/hidden-tales-base-3/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_87 } from "../../../games/game-66333f70937d97accbf169e1/base-68d2bda07dc09467031ac066/node_modules/@games/hidden-tales-collect-middle/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_88 } from "../../../games/game-6644b6a2937d97accbf26c30/base-6644c147937d97accbf26d7a/node_modules/@games/word-roll/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_89 } from "../../../games/game-6644b6a2937d97accbf26c30/base-6824520516f552e843b40bfa/node_modules/@games/word-roll-anagram/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_90 } from "../../../games/game-66f168190255a9f8088f2134/base-66f168970255a9f8088f2152/node_modules/@games/jigsaw/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_91 } from "../../../games/game-66fea2d30255a9f80892a1ec/base-66fea3990255a9f80892a213/node_modules/@games/html5-ps/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_92 } from "../../../games/game-673dd19192e99634ba8d569e/base-673dd36992e99634ba8d56f9/node_modules/@games/cwd-search/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_93 } from "../../../games/game-673f847e92e99634ba8f7826/base-673f907e92e99634ba8f7994/node_modules/@games/e_com/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_94 } from "../../../games/game-6744875ec1b59287554cde94/base-67448825c1b59287554cdeaa/node_modules/@games/match-three/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_95 } from "../../../games/game-6744875ec1b59287554cde94/base-67def4a677b36b5408696a9c/node_modules/@games/match-three-rocks/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_96 } from "../../../games/game-6744875ec1b59287554cde94/base-682c950b01e210fd5ba8be14/node_modules/@games/match-three-rocks-prison-escape/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_97 } from "../../../games/game-67603fb092e99634ba91ed45/base-67603ff392e99634ba91ed64/node_modules/@games/wordhane/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_98 } from "../../../games/game-6762dc9292e99634ba92f290/base-6762e1e992e99634ba92f35e/node_modules/@games/sort-out/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_99 } from "../../../games/game-679922d916f552e843a1446b/base-679923a916f552e843a14499/node_modules/@games/fighter-merge/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_100 } from "../../../games/game-67a9e274c1b59287554ffc88/base-67a9e422c1b59287554ffcc2/node_modules/@games/cryptogram_ps/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_101 } from "../../../games/game-67c1a8b6c61b8ffa997aaf24/base-67c1b5bcc61b8ffa997ac2fa/node_modules/@games/tacticus-3d-base-1/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_102 } from "../../../games/game-67c98f9f603fc771f7be949a/base-67c99064603fc771f7be94c1/node_modules/@games/top-drives/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_103 } from "../../../games/game-67f63c4516f552e843aef7b6/base-67f63c8516f552e843aef7d0/node_modules/@games/word-search-solitaire-ps/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_104 } from "../../../games/game-680b3fd577b36b54086bd1f4/base-680b410b77b36b54086bd226/node_modules/@games/f-1-clash/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_105 } from "../../../games/game-680b3fd577b36b54086bd1f4/base-6822e7a9217e44c32fe54164/node_modules/@games/f-1-clash-selection/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_106 } from "../../../games/game-680b3fd577b36b54086bd1f4/base-68de25601dff1103faea015f/node_modules/@games/f1-clash-cyteamdrivers/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_107 } from "../../../games/game-680b3fd577b36b54086bd1f4/base-68ee539d9fdc569d6bbd213d/node_modules/@games/f-1-clash-drs/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_108 } from "../../../games/game-68147c6b16f552e843b09b8f/base-68148d8816f552e843b09e0b/node_modules/@games/crossword-go/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_109 } from "../../../games/game-681492b0f8781281fbdebab1/base-68149b56f8781281fbdebbe8/node_modules/@games/wonder-blast/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_110 } from "../../../games/game-682de1c2225b4401253dfd88/base-682f156db2e891706cca5c8d/node_modules/@games/heroes-of-history-base-1/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_111 } from "../../../games/game-6852a04101e210fd5baae9a7/base-6852bf7b01e210fd5baaef07/node_modules/@games/bloom-city-match-main/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_112 } from "../../../games/game-6855138e934c54b913ec620e/base-685513fb934c54b913ec622d/node_modules/@games/video-game-html-ps/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_113 } from "../../../games/game-6870126bffe7d0a0c6cf9488/base-6870d741ffe7d0a0c6cf9c04/node_modules/@games/matchcreek-change-parts/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_114 } from "../../../games/game-6870126bffe7d0a0c6cf9488/base-68e90dc63aaefa5a41c2c56c/node_modules/@games/matchcreek-rescue/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_115 } from "../../../games/game-68711421dd966bd6acd61b2d/base-68711d90dd966bd6acd61d95/node_modules/@games/bloons-td-3d-base-1/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_116 } from "../../../games/game-689dc000b58a71fcc12c1dde/base-689dc1ebb58a71fcc12c1e28/node_modules/@games/word-master/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_117 } from "../../../games/game-689dc000b58a71fcc12c1dde/base-6925645a60ce410ab5d2ca48/node_modules/@games/word-master-left-list/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_118 } from "../../../games/game-689dc000b58a71fcc12c1dde/base-69675e39e4e59712b499f9da/node_modules/@games/word-master-daily/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_119 } from "../../../games/game-689dc000b58a71fcc12c1dde/base-6a3ce4c1f83abc415ef2a335/node_modules/@games/word-master-list/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_120 } from "../../../games/game-689ded63b58a71fcc12ca44a/base-689dede3b58a71fcc12ca466/node_modules/@games/family-feud-base-1/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_121 } from "../../../games/game-68ad55371f962e55b79ee2ce/base-68ad629f1f962e55b79ef493/node_modules/@games/word-connect/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_122 } from "../../../games/game-68bebf3101091b28ab4bc634/base-68bebf7d01091b28ab4bc64e/node_modules/@games/town-match/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_123 } from "../../../games/game-68bebf3101091b28ab4bc634/base-69fb56e585e44162352eba45/node_modules/@games/match-on-boosters/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_124 } from "../../../games/game-68c846e2d41928d12b940cfd/base-68c8472c6e565bd173d48412/node_modules/@games/match-squad-core-gameplay/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_125 } from "../../../games/game-68c846e2d41928d12b940cfd/base-68e6127cba0e9ba0b83aae6d/node_modules/@games/match-squad-cairo-stairs/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_126 } from "../../../games/game-68f60fd436168a5d713986a1/base-68f60fdfca5b335d7d410a42/node_modules/@games/jigsaw-selection/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_127 } from "../../../games/game-690c5e87c9e53de5066d6a07/base-690c5ef06f2578e5730a3f72/node_modules/@games/jig-picture/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_128 } from "../../../games/game-69285d21da1771d94d2727a1/base-69285de0afc190dd642d5d82/node_modules/@games/nice-cream/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_129 } from "../../../games/game-695f63420eb4a48a9e39b942/base-695f63443098588ae66c46f7/node_modules/@games/jigsolitaire-ps/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_130 } from "../../../games/game-69685e6d7bddb93c13921c1a/base-69685e96a1029e3d2160184d/node_modules/@games/cross-numbers/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_131 } from "../../../games/game-6968d0966becd95f675f002b/base-6968d0b6c2dc43603732e8fa/node_modules/@games/word-mosaic/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_132 } from "../../../games/game-6971f7d01b07b8cc2dc7ea9b/base-6971f7da01c944cc7b14b1b7/node_modules/@games/sudoku-ps/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_133 } from "../../../games/game-69a1808c8a131a2568e0d27f/base-69a180e90e3b5a25fd6fc228/node_modules/@games/three-js-template/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_134 } from "../../../games/game-69c628b4bd4b73330eb1f822/base-69c628dbb830ec33f33d38d9/node_modules/@games/hexa-tap-away/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_135 } from "../../../games/game-69ca1b2d1555da4e9bb8c13f/base-69ca1b65a753c74efe604ba4/node_modules/@games/make-it-wonder/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_136 } from "../../../games/game-69ddeebba91765c06b00b555/base-69ddef00bbde9ac0cef06a9d/node_modules/@games/search-it/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_137 } from "../../../games/game-6a69a26d4021ba2f3181f5f1/base-6a69a29242abf630309a9b75/node_modules/@games/bubble-drop/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_138 } from "../../../games/game-6a6b5429d8e3c251379b214f/base-6a6b58c3adef5f63048571fc/node_modules/@games/empires-and-puzzles-core-gameplay/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_139 } from "../../../games/game-6a6b5429d8e3c251379b214f/base-6a8846e60b2d421350da777b/node_modules/@games/empires-and-puzzles-hack-and-slash/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_140 } from "../../../games/game-6a6b5429d8e3c251379b214f/base-6a9eb5617bf58dc206580e51/node_modules/@games/empires-and-puzzles-enemy-horde/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_141 } from "../../../games/game-6a6b5429d8e3c251379b214f/base-6aa3fa99a84d1175ff3ebc16/node_modules/@games/empires-and-puzzles-baby-dragon/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_142 } from "../../../games/game-6a6b5429d8e3c251379b214f/base-6aad2aab36f8d84e243be73b/node_modules/@games/empires-and-puzzles-gate-defense/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_143 } from "../../../games/game-6a6b5429d8e3c251379b214f/base-6ab5208b6812939a39c3410e/node_modules/@games/empires-and-puzzles-bridge/src/gameConfig/defaultGameConfig.js";
import { defaultGameConfig as config_144 } from "../../../games/game-6a6b5429d8e3c251379b214f/base-6ac4fbcf098f4e70a82aed10/node_modules/@games/empires-and-puzzles-tower-heroes/src/gameConfig/defaultGameConfig.js";

export const games = [
  {
    "gameId": "5f5b691eb75dc0c7b89b2492",
    "baseId": "5f5b691eb75dc0c7b89b2493",
    "group": "@games",
    "name": "solitaireguru",
    "pkgName": "@games/solitaireguru"
  },
  {
    "gameId": "601a6443b3e245291110ac7a",
    "baseId": "601a649cb3e245291110acce",
    "group": "@games",
    "name": "wowguru",
    "pkgName": "@games/wowguru"
  },
  {
    "gameId": "601a6443b3e245291110ac7a",
    "baseId": "6103eaf12eae9d3e856d6ec8",
    "group": "@games",
    "name": "wowgurubase2",
    "pkgName": "@games/wowgurubase2"
  },
  {
    "gameId": "601a6443b3e245291110ac7a",
    "baseId": "615df9f441e1e0829ab60118",
    "group": "@games",
    "name": "wowgurubase3",
    "pkgName": "@games/wowgurubase3"
  },
  {
    "gameId": "601a6443b3e245291110ac7a",
    "baseId": "6397080fa16dbba4ba8df419",
    "group": "@games",
    "name": "wowgurubase4",
    "pkgName": "@games/wowgurubase4"
  },
  {
    "gameId": "601a6443b3e245291110ac7a",
    "baseId": "63970bb3a16dbba4ba8df48a",
    "group": "@games",
    "name": "wowgurubase5",
    "pkgName": "@games/wowgurubase5"
  },
  {
    "gameId": "601a6443b3e245291110ac7a",
    "baseId": "6613bbb840aceaef5d8ca8fd",
    "group": "@games",
    "name": "crossword-jam-fugo",
    "pkgName": "@games/crossword-jam-fugo"
  },
  {
    "gameId": "601a6443b3e245291110ac7a",
    "baseId": "69d4b08d035de1478c5313a6",
    "group": "@games",
    "name": "wow-guru-cj-top",
    "pkgName": "@games/wow-guru-cj-top"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "603ce698a91fee82f50336fe",
    "group": "@games",
    "name": "wow",
    "pkgName": "@games/wow"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "650d4cfef1e29aa6e06d261f",
    "group": "@games",
    "name": "wowBase2",
    "pkgName": "@games/wowBase2"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "651a6d1f1bc1b828d545667b",
    "group": "@games",
    "name": "wowBase3",
    "pkgName": "@games/wowBase3"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "6530e2601904b92b4fbe379d",
    "group": "@games",
    "name": "wowBase4",
    "pkgName": "@games/wowBase4"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "653777541904b92b4fbec721",
    "group": "@games",
    "name": "wowBase5",
    "pkgName": "@games/wowBase5"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "664df9c5bb75a0017c85a6aa",
    "group": "@games",
    "name": "grammar-game",
    "pkgName": "@games/grammar-game"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "6777f21d92e99634ba954119",
    "group": "@games",
    "name": "wow-spelling-bee",
    "pkgName": "@games/wow-spelling-bee"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "67a103fb16f552e843a45d87",
    "group": "@games",
    "name": "wow100dAutoplaySIP",
    "pkgName": "@games/wow100dAutoplaySIP"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "67b59c4916f552e843a82179",
    "group": "@games",
    "name": "quiz-wtw",
    "pkgName": "@games/quiz-wtw"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "6818a35816f552e843b1fb97",
    "group": "@games",
    "name": "wow-hintboard",
    "pkgName": "@games/wow-hintboard"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "688cb722b58a71fcc12a7ada",
    "group": "@games",
    "name": "wowzen-hintboard",
    "pkgName": "@games/wowzen-hintboard"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "68a568a7b58a71fcc12cdcd6",
    "group": "@games",
    "name": "wow-classic-phaser-3-80",
    "pkgName": "@games/wow-classic-phaser-3-80"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "68bec1dface07b66002a8ea4",
    "group": "@games",
    "name": "wowzen-daily-mode",
    "pkgName": "@games/wowzen-daily-mode"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "68c966eb2bf654ac1ba732c2",
    "group": "@games",
    "name": "wow-cola-fast",
    "pkgName": "@games/wow-cola-fast"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "68f205bff9752f622e2aaf62",
    "group": "@games",
    "name": "wow-5-level-select",
    "pkgName": "@games/wow-5-level-select"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "68f9f3f9ac586102dd22f713",
    "group": "@games",
    "name": "wow-zen-3-word-hint",
    "pkgName": "@games/wow-zen-3-word-hint"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "6916ddd43a547fddee788a46",
    "group": "@games",
    "name": "wow-wheel-arrow-selection",
    "pkgName": "@games/wow-wheel-arrow-selection"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "691efc10f0ad3f159bc35c77",
    "group": "@games",
    "name": "wow-name-city",
    "pkgName": "@games/wow-name-city"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "6936ce56fc02f9d8109d2ae6",
    "group": "@games",
    "name": "wow-b-hb",
    "pkgName": "@games/wow-b-hb"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "693ac4e55572221276ab43b8",
    "group": "@games",
    "name": "wow-opponent",
    "pkgName": "@games/wow-opponent"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "69dc56d014010a01d60b8a78",
    "group": "@games",
    "name": "wow-100-d-new",
    "pkgName": "@games/wow-100-d-new"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "6a2a5369da0eee2da0737d4b",
    "group": "@games",
    "name": "wow-word-list-keyboard",
    "pkgName": "@games/wow-word-list-keyboard"
  },
  {
    "gameId": "603ce43ea91fee82f50334d3",
    "baseId": "6a3e8d87be78e15762bd6a64",
    "group": "@games",
    "name": "wow-zen-crossword",
    "pkgName": "@games/wow-zen-crossword"
  },
  {
    "gameId": "605cc7b259a203d77244525c",
    "baseId": "605cc8a259a203d772445287",
    "group": "@games",
    "name": "wowsearch",
    "pkgName": "@games/wowsearch"
  },
  {
    "gameId": "605cc7b259a203d77244525c",
    "baseId": "654b3d221904b92b4fbeeb53",
    "group": "@games",
    "name": "wordsearchbase2",
    "pkgName": "@games/wordsearchbase2"
  },
  {
    "gameId": "605cc7b259a203d77244525c",
    "baseId": "69a002cef372556bcdea313f",
    "group": "@games",
    "name": "wow-zen-search",
    "pkgName": "@games/wow-zen-search"
  },
  {
    "gameId": "605cc7b259a203d77244525c",
    "baseId": "6a60c472c465a15559854f2d",
    "group": "@games",
    "name": "wow-search-cola-fast",
    "pkgName": "@games/wow-search-cola-fast"
  },
  {
    "gameId": "6079680d222d9801f96bab74",
    "baseId": "60796c54222d9801f96bac5b",
    "group": "@games",
    "name": "colorbump3d",
    "pkgName": "@games/colorbump3d"
  },
  {
    "gameId": "614081de93ddb73076a1538a",
    "baseId": "6140893d93ddb73076a1554e",
    "group": "@games",
    "name": "hunter-assassin-2",
    "pkgName": "@games/hunter-assassin-2"
  },
  {
    "gameId": "619e14fb68af90fbc06a4345",
    "baseId": "619e14fb68af90fbc06a4345",
    "group": "@apps",
    "name": "endcard",
    "pkgName": "@apps/endcard"
  },
  {
    "gameId": "61af33d3222f4485886da806",
    "baseId": "61af33d3222f4485886da806",
    "group": "@apps",
    "name": "atlasgame",
    "pkgName": "@apps/atlasgame"
  },
  {
    "gameId": "61af33d3222f4485886da806",
    "baseId": "623c457358d6dd7853a01a00",
    "group": "@apps",
    "name": "video-game",
    "pkgName": "@apps/video-game"
  },
  {
    "gameId": "61fd1d864e862442e1bd67db",
    "baseId": "61fd1eb64e862442e1bd6828",
    "group": "@games",
    "name": "word-letter",
    "pkgName": "@games/word-letter"
  },
  {
    "gameId": "62581d4558d6dd7853a161e8",
    "baseId": "625984d758d6dd7853a1bd9d",
    "group": "@games",
    "name": "balls-master",
    "pkgName": "@games/balls-master"
  },
  {
    "gameId": "625e7d9c152625add904a679",
    "baseId": "625e7ecf152625add904a6d9",
    "group": "@games",
    "name": "ball-blast",
    "pkgName": "@games/ball-blast"
  },
  {
    "gameId": "6266a66a152625add904bce8",
    "baseId": "6266a6fe152625add904bd19",
    "group": "@games",
    "name": "tap-on-time",
    "pkgName": "@games/tap-on-time"
  },
  {
    "gameId": "6267bb9ee12f014cd14b6c9f",
    "baseId": "6267c05ae12f014cd14b6eed",
    "group": "@games",
    "name": "game-of-words",
    "pkgName": "@games/game-of-words"
  },
  {
    "gameId": "627baaf241f6066717ff413f",
    "baseId": "627babd141f6066717ff417d",
    "group": "@games",
    "name": "name-the-activity",
    "pkgName": "@games/name-the-activity"
  },
  {
    "gameId": "62864cd341f6066717ff801e",
    "baseId": "6286500f41f6066717ff80c7",
    "group": "@games",
    "name": "mad-smash",
    "pkgName": "@games/mad-smash"
  },
  {
    "gameId": "629e01961f70c95b7fd67b3a",
    "baseId": "629e0b671f70c95b7fd67de8",
    "group": "@games",
    "name": "wordsquare",
    "pkgName": "@games/wordsquare"
  },
  {
    "gameId": "629e01961f70c95b7fd67b3a",
    "baseId": "6450ec1566c580b614f8bb06",
    "group": "@games",
    "name": "wordsquarebase2",
    "pkgName": "@games/wordsquarebase2"
  },
  {
    "gameId": "629e01961f70c95b7fd67b3a",
    "baseId": "68adabd0b58a71fcc12e2192",
    "group": "@games",
    "name": "wow-hexa-mahjong",
    "pkgName": "@games/wow-hexa-mahjong"
  },
  {
    "gameId": "629e01961f70c95b7fd67b3a",
    "baseId": "69b7b831238b6de497d7803e",
    "group": "@games",
    "name": "wow-guru-hexa",
    "pkgName": "@games/wow-guru-hexa"
  },
  {
    "gameId": "62a09e2041f6066717fff686",
    "baseId": "62a0a15241f6066717fff6ee",
    "group": "@apps",
    "name": "video-game-html",
    "pkgName": "@apps/video-game-html"
  },
  {
    "gameId": "62b9a830cc0ad8e0a9eaa81c",
    "baseId": "62b9b2a2cc0ad8e0a9eaa9b7",
    "group": "@apps",
    "name": "atlas-game-html",
    "pkgName": "@apps/atlas-game-html"
  },
  {
    "gameId": "62e8c71357d6958461cbe9d6",
    "baseId": "62e8c9a757d6958461cbea45",
    "group": "@games",
    "name": "crossword-playable",
    "pkgName": "@games/crossword-playable"
  },
  {
    "gameId": "62f50cd857d6958461cc54d3",
    "baseId": "62f50da057d6958461cc550e",
    "group": "@games",
    "name": "crossword-jam",
    "pkgName": "@games/crossword-jam"
  },
  {
    "gameId": "62f50cd857d6958461cc54d3",
    "baseId": "6332e467d12f27f917df1ac0",
    "group": "@games",
    "name": "cwdJam2",
    "pkgName": "@games/cwdJam2"
  },
  {
    "gameId": "62f50cd857d6958461cc54d3",
    "baseId": "66b5fe200f1aafc87731fcb5",
    "group": "@games",
    "name": "crossword-jam-base3",
    "pkgName": "@games/crossword-jam-base3"
  },
  {
    "gameId": "62f6121457d6958461cc7ef0",
    "baseId": "62f612be60e29e02961bbfd6",
    "group": "@games",
    "name": "wordsquare-playsimple",
    "pkgName": "@games/wordsquare-playsimple"
  },
  {
    "gameId": "6318807957d6958461cd5fc1",
    "baseId": "6318818257d6958461cd6005",
    "group": "@games",
    "name": "word-wars",
    "pkgName": "@games/word-wars"
  },
  {
    "gameId": "6318807957d6958461cd5fc1",
    "baseId": "6461dcd4f01fdda7a6d2769b",
    "group": "@games",
    "name": "wordWarsBase2",
    "pkgName": "@games/wordWarsBase2"
  },
  {
    "gameId": "632aca17d12f27f917de59ec",
    "baseId": "632acab6d12f27f917de5a16",
    "group": "@games",
    "name": "anagram",
    "pkgName": "@games/anagram"
  },
  {
    "gameId": "635fe93ded1431b3f7d2215c",
    "baseId": "635fe9eaed1431b3f7d22181",
    "group": "@games",
    "name": "alien_shooter",
    "pkgName": "@games/alien_shooter"
  },
  {
    "gameId": "6371ed43dd2735639e05b6ab",
    "baseId": "637345bcdd2735639e05c8b0",
    "group": "@games",
    "name": "sunday-solitaire",
    "pkgName": "@games/sunday-solitaire"
  },
  {
    "gameId": "63f8a26aa2afbaeb5f803de3",
    "baseId": "63f8a309a2afbaeb5f803e1f",
    "group": "@games",
    "name": "word-surf",
    "pkgName": "@games/word-surf"
  },
  {
    "gameId": "63ff24d8f1b9d0fb8487223f",
    "baseId": "63ff2e7ff1b9d0fb84872367",
    "group": "@games",
    "name": "word-search-ps",
    "pkgName": "@games/word-search-ps"
  },
  {
    "gameId": "63ff24d8f1b9d0fb8487223f",
    "baseId": "6527bf7c1904b92b4fbd6721",
    "group": "@games",
    "name": "wordsearchpsbase2",
    "pkgName": "@games/wordsearchpsbase2"
  },
  {
    "gameId": "640060027d19caf1ca799d1f",
    "baseId": "64007d1f7d19caf1ca79a27b",
    "group": "@games",
    "name": "scratch-html",
    "pkgName": "@games/scratch-html"
  },
  {
    "gameId": "649a7061f01fdda7a6d44598",
    "baseId": "649a90aaf01fdda7a6d44888",
    "group": "@games",
    "name": "wizard-hero",
    "pkgName": "@games/wizard-hero"
  },
  {
    "gameId": "656f16ee7e3091d6e2607a1d",
    "baseId": "6570216c7e3091d6e2607d91",
    "group": "@games",
    "name": "differences",
    "pkgName": "@games/differences"
  },
  {
    "gameId": "656f16ee7e3091d6e2607a1d",
    "baseId": "69ef52e55b3df618e76de9c9",
    "group": "@games",
    "name": "find-differences-image-match",
    "pkgName": "@games/find-differences-image-match"
  },
  {
    "gameId": "65a6576f99010ea68565fb77",
    "baseId": "65a6644b99010ea68565fd0e",
    "group": "@games",
    "name": "tile-match-ps",
    "pkgName": "@games/tile-match-ps"
  },
  {
    "gameId": "65a6576f99010ea68565fb77",
    "baseId": "6879f875b58a71fcc127119f",
    "group": "@games",
    "name": "tile-match-version-2",
    "pkgName": "@games/tile-match-version-2"
  },
  {
    "gameId": "65cb16fc897ec6f9db711354",
    "baseId": "65cb1d1d897ec6f9db711418",
    "group": "@games",
    "name": "2248-tiles-ps",
    "pkgName": "@games/2248-tiles-ps"
  },
  {
    "gameId": "65fae6d540aceaef5d88bd51",
    "baseId": "65fae73d40aceaef5d88bd70",
    "group": "@games",
    "name": "bloxie_base1",
    "pkgName": "@games/bloxie_base1"
  },
  {
    "gameId": "661504b840aceaef5d8cba1f",
    "baseId": "6615052f40aceaef5d8cba51",
    "group": "@games",
    "name": "block-buster",
    "pkgName": "@games/block-buster"
  },
  {
    "gameId": "6615087940aceaef5d8cbace",
    "baseId": "6615094d40aceaef5d8cbafd",
    "group": "@games",
    "name": "endCard-html",
    "pkgName": "@games/endCard-html"
  },
  {
    "gameId": "6627943e40aceaef5d8eec81",
    "baseId": "6627a1da40aceaef5d8eee0d",
    "group": "@games",
    "name": "find-hidden-objects",
    "pkgName": "@games/find-hidden-objects"
  },
  {
    "gameId": "6627943e40aceaef5d8eec81",
    "baseId": "68273d6016f552e843b5154c",
    "group": "@games",
    "name": "find-hidden-object-base-2",
    "pkgName": "@games/find-hidden-object-base-2"
  },
  {
    "gameId": "6627943e40aceaef5d8eec81",
    "baseId": "6889febab58a71fcc129ac1c",
    "group": "@games",
    "name": "find-hidden-object-two-level",
    "pkgName": "@games/find-hidden-object-two-level"
  },
  {
    "gameId": "6627943e40aceaef5d8eec81",
    "baseId": "68ef701d42950b539b7c40b5",
    "group": "@games",
    "name": "find-hidden-object-two-level-base-2",
    "pkgName": "@games/find-hidden-object-two-level-base-2"
  },
  {
    "gameId": "6627943e40aceaef5d8eec81",
    "baseId": "694bcf96a600611cdb08c3a2",
    "group": "@games",
    "name": "find-hidden-object-tapslide",
    "pkgName": "@games/find-hidden-object-tapslide"
  },
  {
    "gameId": "6627943e40aceaef5d8eec81",
    "baseId": "699eb28720f540073a45a111",
    "group": "@games",
    "name": "find-hidden-object-collect-objects",
    "pkgName": "@games/find-hidden-object-collect-objects"
  },
  {
    "gameId": "6627943e40aceaef5d8eec81",
    "baseId": "69afd3f598e86c1ebb1a8c75",
    "group": "@games",
    "name": "find-hidden-object-panoramic-map",
    "pkgName": "@games/find-hidden-object-panoramic-map"
  },
  {
    "gameId": "6627943e40aceaef5d8eec81",
    "baseId": "69e8affa3f5ac655e8557c36",
    "group": "@games",
    "name": "find-hidden-object-6-level",
    "pkgName": "@games/find-hidden-object-6-level"
  },
  {
    "gameId": "66333f70937d97accbf169e1",
    "baseId": "66334529937d97accbf16a85",
    "group": "@games",
    "name": "hidden-tiles",
    "pkgName": "@games/hidden-tiles"
  },
  {
    "gameId": "66333f70937d97accbf169e1",
    "baseId": "668e67310f1aafc87706b7d0",
    "group": "@games",
    "name": "hiddenObjects",
    "pkgName": "@games/hiddenObjects"
  },
  {
    "gameId": "66333f70937d97accbf169e1",
    "baseId": "67f6eb9516f552e843af42cf",
    "group": "@games",
    "name": "hidden-tales-base-3",
    "pkgName": "@games/hidden-tales-base-3"
  },
  {
    "gameId": "66333f70937d97accbf169e1",
    "baseId": "68d2bda07dc09467031ac066",
    "group": "@games",
    "name": "hidden-tales-collect-middle",
    "pkgName": "@games/hidden-tales-collect-middle"
  },
  {
    "gameId": "6644b6a2937d97accbf26c30",
    "baseId": "6644c147937d97accbf26d7a",
    "group": "@games",
    "name": "word-roll",
    "pkgName": "@games/word-roll"
  },
  {
    "gameId": "6644b6a2937d97accbf26c30",
    "baseId": "6824520516f552e843b40bfa",
    "group": "@games",
    "name": "word-roll-anagram",
    "pkgName": "@games/word-roll-anagram"
  },
  {
    "gameId": "66f168190255a9f8088f2134",
    "baseId": "66f168970255a9f8088f2152",
    "group": "@games",
    "name": "jigsaw",
    "pkgName": "@games/jigsaw"
  },
  {
    "gameId": "66fea2d30255a9f80892a1ec",
    "baseId": "66fea3990255a9f80892a213",
    "group": "@games",
    "name": "html5-ps",
    "pkgName": "@games/html5-ps"
  },
  {
    "gameId": "673dd19192e99634ba8d569e",
    "baseId": "673dd36992e99634ba8d56f9",
    "group": "@games",
    "name": "cwd-search",
    "pkgName": "@games/cwd-search"
  },
  {
    "gameId": "673f847e92e99634ba8f7826",
    "baseId": "673f907e92e99634ba8f7994",
    "group": "@games",
    "name": "e_com",
    "pkgName": "@games/e_com"
  },
  {
    "gameId": "6744875ec1b59287554cde94",
    "baseId": "67448825c1b59287554cdeaa",
    "group": "@games",
    "name": "match-three",
    "pkgName": "@games/match-three"
  },
  {
    "gameId": "6744875ec1b59287554cde94",
    "baseId": "67def4a677b36b5408696a9c",
    "group": "@games",
    "name": "match-three-rocks",
    "pkgName": "@games/match-three-rocks"
  },
  {
    "gameId": "6744875ec1b59287554cde94",
    "baseId": "682c950b01e210fd5ba8be14",
    "group": "@games",
    "name": "match-three-rocks-prison-escape",
    "pkgName": "@games/match-three-rocks-prison-escape"
  },
  {
    "gameId": "67603fb092e99634ba91ed45",
    "baseId": "67603ff392e99634ba91ed64",
    "group": "@games",
    "name": "wordhane",
    "pkgName": "@games/wordhane"
  },
  {
    "gameId": "6762dc9292e99634ba92f290",
    "baseId": "6762e1e992e99634ba92f35e",
    "group": "@games",
    "name": "sort-out",
    "pkgName": "@games/sort-out"
  },
  {
    "gameId": "679922d916f552e843a1446b",
    "baseId": "679923a916f552e843a14499",
    "group": "@games",
    "name": "fighter-merge",
    "pkgName": "@games/fighter-merge"
  },
  {
    "gameId": "67a9e274c1b59287554ffc88",
    "baseId": "67a9e422c1b59287554ffcc2",
    "group": "@games",
    "name": "cryptogram_ps",
    "pkgName": "@games/cryptogram_ps"
  },
  {
    "gameId": "67c1a8b6c61b8ffa997aaf24",
    "baseId": "67c1b5bcc61b8ffa997ac2fa",
    "group": "@games",
    "name": "tacticus-3d-base-1",
    "pkgName": "@games/tacticus-3d-base-1"
  },
  {
    "gameId": "67c98f9f603fc771f7be949a",
    "baseId": "67c99064603fc771f7be94c1",
    "group": "@games",
    "name": "top-drives",
    "pkgName": "@games/top-drives"
  },
  {
    "gameId": "67f63c4516f552e843aef7b6",
    "baseId": "67f63c8516f552e843aef7d0",
    "group": "@games",
    "name": "word-search-solitaire-ps",
    "pkgName": "@games/word-search-solitaire-ps"
  },
  {
    "gameId": "680b3fd577b36b54086bd1f4",
    "baseId": "680b410b77b36b54086bd226",
    "group": "@games",
    "name": "f-1-clash",
    "pkgName": "@games/f-1-clash"
  },
  {
    "gameId": "680b3fd577b36b54086bd1f4",
    "baseId": "6822e7a9217e44c32fe54164",
    "group": "@games",
    "name": "f-1-clash-selection",
    "pkgName": "@games/f-1-clash-selection"
  },
  {
    "gameId": "680b3fd577b36b54086bd1f4",
    "baseId": "68de25601dff1103faea015f",
    "group": "@games",
    "name": "f1-clash-cyteamdrivers",
    "pkgName": "@games/f1-clash-cyteamdrivers"
  },
  {
    "gameId": "680b3fd577b36b54086bd1f4",
    "baseId": "68ee539d9fdc569d6bbd213d",
    "group": "@games",
    "name": "f-1-clash-drs",
    "pkgName": "@games/f-1-clash-drs"
  },
  {
    "gameId": "68147c6b16f552e843b09b8f",
    "baseId": "68148d8816f552e843b09e0b",
    "group": "@games",
    "name": "crossword-go",
    "pkgName": "@games/crossword-go"
  },
  {
    "gameId": "681492b0f8781281fbdebab1",
    "baseId": "68149b56f8781281fbdebbe8",
    "group": "@games",
    "name": "wonder-blast",
    "pkgName": "@games/wonder-blast"
  },
  {
    "gameId": "682de1c2225b4401253dfd88",
    "baseId": "682f156db2e891706cca5c8d",
    "group": "@games",
    "name": "heroes-of-history-base-1",
    "pkgName": "@games/heroes-of-history-base-1"
  },
  {
    "gameId": "6852a04101e210fd5baae9a7",
    "baseId": "6852bf7b01e210fd5baaef07",
    "group": "@games",
    "name": "bloom-city-match-main",
    "pkgName": "@games/bloom-city-match-main"
  },
  {
    "gameId": "6855138e934c54b913ec620e",
    "baseId": "685513fb934c54b913ec622d",
    "group": "@games",
    "name": "video-game-html-ps",
    "pkgName": "@games/video-game-html-ps"
  },
  {
    "gameId": "6870126bffe7d0a0c6cf9488",
    "baseId": "6870d741ffe7d0a0c6cf9c04",
    "group": "@games",
    "name": "matchcreek-change-parts",
    "pkgName": "@games/matchcreek-change-parts"
  },
  {
    "gameId": "6870126bffe7d0a0c6cf9488",
    "baseId": "68e90dc63aaefa5a41c2c56c",
    "group": "@games",
    "name": "matchcreek-rescue",
    "pkgName": "@games/matchcreek-rescue"
  },
  {
    "gameId": "68711421dd966bd6acd61b2d",
    "baseId": "68711d90dd966bd6acd61d95",
    "group": "@games",
    "name": "bloons-td-3d-base-1",
    "pkgName": "@games/bloons-td-3d-base-1"
  },
  {
    "gameId": "689dc000b58a71fcc12c1dde",
    "baseId": "689dc1ebb58a71fcc12c1e28",
    "group": "@games",
    "name": "word-master",
    "pkgName": "@games/word-master"
  },
  {
    "gameId": "689dc000b58a71fcc12c1dde",
    "baseId": "6925645a60ce410ab5d2ca48",
    "group": "@games",
    "name": "word-master-left-list",
    "pkgName": "@games/word-master-left-list"
  },
  {
    "gameId": "689dc000b58a71fcc12c1dde",
    "baseId": "69675e39e4e59712b499f9da",
    "group": "@games",
    "name": "word-master-daily",
    "pkgName": "@games/word-master-daily"
  },
  {
    "gameId": "689dc000b58a71fcc12c1dde",
    "baseId": "6a3ce4c1f83abc415ef2a335",
    "group": "@games",
    "name": "word-master-list",
    "pkgName": "@games/word-master-list"
  },
  {
    "gameId": "689dc000b58a71fcc12c1dde",
    "baseId": "6aa7b0b60a0e6d227a1cb538",
    "group": "@games",
    "name": "playengine",
    "pkgName": "@games/playengine"
  },
  {
    "gameId": "689ded63b58a71fcc12ca44a",
    "baseId": "689dede3b58a71fcc12ca466",
    "group": "@games",
    "name": "family-feud-base-1",
    "pkgName": "@games/family-feud-base-1"
  },
  {
    "gameId": "68ad55371f962e55b79ee2ce",
    "baseId": "68ad629f1f962e55b79ef493",
    "group": "@games",
    "name": "word-connect",
    "pkgName": "@games/word-connect"
  },
  {
    "gameId": "68bebf3101091b28ab4bc634",
    "baseId": "68bebf7d01091b28ab4bc64e",
    "group": "@games",
    "name": "town-match",
    "pkgName": "@games/town-match"
  },
  {
    "gameId": "68bebf3101091b28ab4bc634",
    "baseId": "69fb56e585e44162352eba45",
    "group": "@games",
    "name": "match-on-boosters",
    "pkgName": "@games/match-on-boosters"
  },
  {
    "gameId": "68c846e2d41928d12b940cfd",
    "baseId": "68c8472c6e565bd173d48412",
    "group": "@games",
    "name": "match-squad-core-gameplay",
    "pkgName": "@games/match-squad-core-gameplay"
  },
  {
    "gameId": "68c846e2d41928d12b940cfd",
    "baseId": "68e6127cba0e9ba0b83aae6d",
    "group": "@games",
    "name": "match-squad-cairo-stairs",
    "pkgName": "@games/match-squad-cairo-stairs"
  },
  {
    "gameId": "68f60fd436168a5d713986a1",
    "baseId": "68f60fdfca5b335d7d410a42",
    "group": "@games",
    "name": "jigsaw-selection",
    "pkgName": "@games/jigsaw-selection"
  },
  {
    "gameId": "690c5e87c9e53de5066d6a07",
    "baseId": "690c5ef06f2578e5730a3f72",
    "group": "@games",
    "name": "jig-picture",
    "pkgName": "@games/jig-picture"
  },
  {
    "gameId": "69285d21da1771d94d2727a1",
    "baseId": "69285de0afc190dd642d5d82",
    "group": "@games",
    "name": "nice-cream",
    "pkgName": "@games/nice-cream"
  },
  {
    "gameId": "695f63420eb4a48a9e39b942",
    "baseId": "695f63443098588ae66c46f7",
    "group": "@games",
    "name": "jigsolitaire-ps",
    "pkgName": "@games/jigsolitaire-ps"
  },
  {
    "gameId": "69685e6d7bddb93c13921c1a",
    "baseId": "69685e96a1029e3d2160184d",
    "group": "@games",
    "name": "cross-numbers",
    "pkgName": "@games/cross-numbers"
  },
  {
    "gameId": "6968d0966becd95f675f002b",
    "baseId": "6968d0b6c2dc43603732e8fa",
    "group": "@games",
    "name": "word-mosaic",
    "pkgName": "@games/word-mosaic"
  },
  {
    "gameId": "6971f7d01b07b8cc2dc7ea9b",
    "baseId": "6971f7da01c944cc7b14b1b7",
    "group": "@games",
    "name": "sudoku-ps",
    "pkgName": "@games/sudoku-ps"
  },
  {
    "gameId": "699c4e0d487902dd93c9c77d",
    "baseId": "699c4dfd5ecc58dcbb97adb5",
    "group": "@games",
    "name": "playengine",
    "pkgName": "@games/playengine"
  },
  {
    "gameId": "699c4e0d487902dd93c9c77d",
    "baseId": "6a5e0911b7b9c93b24824240",
    "group": "@games",
    "name": "playengine",
    "pkgName": "@games/playengine"
  },
  {
    "gameId": "699c4e0d487902dd93c9c77d",
    "baseId": "6a7dc4c1bfdc0ce74c041dbd",
    "group": "@games",
    "name": "playengine",
    "pkgName": "@games/playengine"
  },
  {
    "gameId": "69a1808c8a131a2568e0d27f",
    "baseId": "69a180e90e3b5a25fd6fc228",
    "group": "@games",
    "name": "three-js-template",
    "pkgName": "@games/three-js-template"
  },
  {
    "gameId": "69c628b4bd4b73330eb1f822",
    "baseId": "69c628dbb830ec33f33d38d9",
    "group": "@games",
    "name": "hexa-tap-away",
    "pkgName": "@games/hexa-tap-away"
  },
  {
    "gameId": "69ca1b2d1555da4e9bb8c13f",
    "baseId": "69ca1b65a753c74efe604ba4",
    "group": "@games",
    "name": "make-it-wonder",
    "pkgName": "@games/make-it-wonder"
  },
  {
    "gameId": "69ddeebba91765c06b00b555",
    "baseId": "69ddef00bbde9ac0cef06a9d",
    "group": "@games",
    "name": "search-it",
    "pkgName": "@games/search-it"
  },
  {
    "gameId": "6a69a26d4021ba2f3181f5f1",
    "baseId": "6a69a29242abf630309a9b75",
    "group": "@games",
    "name": "bubble-drop",
    "pkgName": "@games/bubble-drop"
  },
  {
    "gameId": "6a6b5429d8e3c251379b214f",
    "baseId": "6a6b58c3adef5f63048571fc",
    "group": "@games",
    "name": "empires-and-puzzles-core-gameplay",
    "pkgName": "@games/empires-and-puzzles-core-gameplay"
  },
  {
    "gameId": "6a6b5429d8e3c251379b214f",
    "baseId": "6a8846e60b2d421350da777b",
    "group": "@games",
    "name": "empires-and-puzzles-hack-and-slash",
    "pkgName": "@games/empires-and-puzzles-hack-and-slash"
  },
  {
    "gameId": "6a6b5429d8e3c251379b214f",
    "baseId": "6a9eb5617bf58dc206580e51",
    "group": "@games",
    "name": "empires-and-puzzles-enemy-horde",
    "pkgName": "@games/empires-and-puzzles-enemy-horde"
  },
  {
    "gameId": "6a6b5429d8e3c251379b214f",
    "baseId": "6aa3fa99a84d1175ff3ebc16",
    "group": "@games",
    "name": "empires-and-puzzles-baby-dragon",
    "pkgName": "@games/empires-and-puzzles-baby-dragon"
  },
  {
    "gameId": "6a6b5429d8e3c251379b214f",
    "baseId": "6aad2aab36f8d84e243be73b",
    "group": "@games",
    "name": "empires-and-puzzles-gate-defense",
    "pkgName": "@games/empires-and-puzzles-gate-defense"
  },
  {
    "gameId": "6a6b5429d8e3c251379b214f",
    "baseId": "6ab5208b6812939a39c3410e",
    "group": "@games",
    "name": "empires-and-puzzles-bridge",
    "pkgName": "@games/empires-and-puzzles-bridge"
  },
  {
    "gameId": "6a6b5429d8e3c251379b214f",
    "baseId": "6ac4fbcf098f4e70a82aed10",
    "group": "@games",
    "name": "empires-and-puzzles-tower-heroes",
    "pkgName": "@games/empires-and-puzzles-tower-heroes"
  }
];

export const previewsGenerated = {
  "5f5b691eb75dc0c7b89b2493": "/5f5b691eb75dc0c7b89b2493-afd5ca5e1efe.html",
  "601a649cb3e245291110acce": "/601a649cb3e245291110acce-3ab6924db49f.html",
  "6103eaf12eae9d3e856d6ec8": "/6103eaf12eae9d3e856d6ec8-1cc563b08ed3.html",
  "615df9f441e1e0829ab60118": "/615df9f441e1e0829ab60118-c71dc5b914cd.html",
  "6397080fa16dbba4ba8df419": "/6397080fa16dbba4ba8df419-bb32166d2f77.html",
  "63970bb3a16dbba4ba8df48a": "/63970bb3a16dbba4ba8df48a-8aec4a36932c.html",
  "6613bbb840aceaef5d8ca8fd": "/6613bbb840aceaef5d8ca8fd-c8905f05183a.html",
  "69d4b08d035de1478c5313a6": "/69d4b08d035de1478c5313a6-12172bbabfbb.html",
  "603ce698a91fee82f50336fe": "/603ce698a91fee82f50336fe-262dbe71db85.html",
  "650d4cfef1e29aa6e06d261f": "/650d4cfef1e29aa6e06d261f-cb71dc6899fb.html",
  "651a6d1f1bc1b828d545667b": "/651a6d1f1bc1b828d545667b-019549fe06da.html",
  "6530e2601904b92b4fbe379d": "/6530e2601904b92b4fbe379d-d1c1a254345d.html",
  "653777541904b92b4fbec721": "/653777541904b92b4fbec721-2f3bc0c4089d.html",
  "664df9c5bb75a0017c85a6aa": "/664df9c5bb75a0017c85a6aa-3e315d939a48.html",
  "6777f21d92e99634ba954119": "/6777f21d92e99634ba954119-09333df307b2.html",
  "67a103fb16f552e843a45d87": "/67a103fb16f552e843a45d87-af33e269e5bc.html",
  "67b59c4916f552e843a82179": "/67b59c4916f552e843a82179-140a9fa1ac64.html",
  "6818a35816f552e843b1fb97": "/6818a35816f552e843b1fb97-f8671c5c8830.html",
  "688cb722b58a71fcc12a7ada": "/688cb722b58a71fcc12a7ada-b9ecb96aa902.html",
  "68a568a7b58a71fcc12cdcd6": "/68a568a7b58a71fcc12cdcd6-9f34b38c9f99.html",
  "68bec1dface07b66002a8ea4": "/68bec1dface07b66002a8ea4-4302e404bf9b.html",
  "68c966eb2bf654ac1ba732c2": "/68c966eb2bf654ac1ba732c2-c3985c87803d.html",
  "68f205bff9752f622e2aaf62": "/68f205bff9752f622e2aaf62-75ab8083d159.html",
  "68f9f3f9ac586102dd22f713": "/68f9f3f9ac586102dd22f713-f0b556e72ae4.html",
  "6916ddd43a547fddee788a46": "/6916ddd43a547fddee788a46-ed3491dd038a.html",
  "691efc10f0ad3f159bc35c77": "/691efc10f0ad3f159bc35c77-2399c800338c.html",
  "6936ce56fc02f9d8109d2ae6": "/6936ce56fc02f9d8109d2ae6-8a3bf5cf56c2.html",
  "693ac4e55572221276ab43b8": "/693ac4e55572221276ab43b8-1e53fba07ce0.html",
  "69dc56d014010a01d60b8a78": "/69dc56d014010a01d60b8a78-2ae04208fa6c.html",
  "6a2a5369da0eee2da0737d4b": "/6a2a5369da0eee2da0737d4b-f2ebd27b902d.html",
  "6a3e8d87be78e15762bd6a64": "/6a3e8d87be78e15762bd6a64-834914250471.html",
  "605cc8a259a203d772445287": "/605cc8a259a203d772445287-6adf79b0831b.html",
  "654b3d221904b92b4fbeeb53": "/654b3d221904b92b4fbeeb53-ad47ed539d55.html",
  "69a002cef372556bcdea313f": "/69a002cef372556bcdea313f-ec02dd6d4e1c.html",
  "6a60c472c465a15559854f2d": "/6a60c472c465a15559854f2d-efe3425eb970.html",
  "60796c54222d9801f96bac5b": "/60796c54222d9801f96bac5b-5ef5fb174432.html",
  "6140893d93ddb73076a1554e": "/6140893d93ddb73076a1554e-c92013eb7c33.html",
  "619e14fb68af90fbc06a4345": "/619e14fb68af90fbc06a4345-8a25bab2f686.html",
  "61af33d3222f4485886da806": "/61af33d3222f4485886da806-f85a01ced7f6.html",
  "623c457358d6dd7853a01a00": "/623c457358d6dd7853a01a00-952545b6de8d.html",
  "61fd1eb64e862442e1bd6828": "/61fd1eb64e862442e1bd6828-6aac27e177fa.html",
  "625984d758d6dd7853a1bd9d": "/625984d758d6dd7853a1bd9d-b8817f0c8d95.html",
  "625e7ecf152625add904a6d9": "/625e7ecf152625add904a6d9-fc8ae4c623e5.html",
  "6266a6fe152625add904bd19": "/6266a6fe152625add904bd19-1191cf0186f4.html",
  "6267c05ae12f014cd14b6eed": "/6267c05ae12f014cd14b6eed-ce200ddd3fa1.html",
  "627babd141f6066717ff417d": "/627babd141f6066717ff417d-a4b686b2b399.html",
  "6286500f41f6066717ff80c7": "/6286500f41f6066717ff80c7-f60550ebf73e.html",
  "629e0b671f70c95b7fd67de8": "/629e0b671f70c95b7fd67de8-01a494cfa88c.html",
  "6450ec1566c580b614f8bb06": "/6450ec1566c580b614f8bb06-86e95019d3d6.html",
  "68adabd0b58a71fcc12e2192": "/68adabd0b58a71fcc12e2192-4dc6509a7dc5.html",
  "69b7b831238b6de497d7803e": "/69b7b831238b6de497d7803e-479b78a325f2.html",
  "62a0a15241f6066717fff6ee": "/62a0a15241f6066717fff6ee-90abec9206f4.html",
  "62b9b2a2cc0ad8e0a9eaa9b7": "/62b9b2a2cc0ad8e0a9eaa9b7-036eadb484cc.html",
  "62e8c9a757d6958461cbea45": "/62e8c9a757d6958461cbea45-54f34d1bc060.html",
  "62f50da057d6958461cc550e": "/62f50da057d6958461cc550e-605482e496d1.html",
  "6332e467d12f27f917df1ac0": "/6332e467d12f27f917df1ac0-db1b10625baf.html",
  "66b5fe200f1aafc87731fcb5": "/66b5fe200f1aafc87731fcb5-ffe5c95740f7.html",
  "62f612be60e29e02961bbfd6": "/62f612be60e29e02961bbfd6-6d0352faf69c.html",
  "6318818257d6958461cd6005": "/6318818257d6958461cd6005-c4a618812823.html",
  "6461dcd4f01fdda7a6d2769b": "/6461dcd4f01fdda7a6d2769b-17adb412b362.html",
  "632acab6d12f27f917de5a16": "/632acab6d12f27f917de5a16-6788849655d8.html",
  "635fe9eaed1431b3f7d22181": "/635fe9eaed1431b3f7d22181-1baa641fca99.html",
  "637345bcdd2735639e05c8b0": "/637345bcdd2735639e05c8b0-9b9f5ff54836.html",
  "63f8a309a2afbaeb5f803e1f": "/63f8a309a2afbaeb5f803e1f-bec8e6ccc40c.html",
  "63ff2e7ff1b9d0fb84872367": "/63ff2e7ff1b9d0fb84872367-1a8b859b6a35.html",
  "6527bf7c1904b92b4fbd6721": "/6527bf7c1904b92b4fbd6721-5af039c17c18.html",
  "64007d1f7d19caf1ca79a27b": "/64007d1f7d19caf1ca79a27b-d5d143d59f0a.html",
  "649a90aaf01fdda7a6d44888": "/649a90aaf01fdda7a6d44888-850574fd4732.html",
  "6570216c7e3091d6e2607d91": "/6570216c7e3091d6e2607d91-4168889dc606.html",
  "69ef52e55b3df618e76de9c9": "/69ef52e55b3df618e76de9c9-eaba41c5345e.html",
  "65a6644b99010ea68565fd0e": "/65a6644b99010ea68565fd0e-e92138304551.html",
  "6879f875b58a71fcc127119f": "/6879f875b58a71fcc127119f-923e094294a9.html",
  "65cb1d1d897ec6f9db711418": "/65cb1d1d897ec6f9db711418-ee186690a094.html",
  "65fae73d40aceaef5d88bd70": "/65fae73d40aceaef5d88bd70-31a98dffc580.html",
  "6615052f40aceaef5d8cba51": "/6615052f40aceaef5d8cba51-dd05b1c4dc21.html",
  "6615094d40aceaef5d8cbafd": "/6615094d40aceaef5d8cbafd-d8cfac438425.html",
  "6627a1da40aceaef5d8eee0d": "/6627a1da40aceaef5d8eee0d-356fe8c461a9.html",
  "68273d6016f552e843b5154c": "/68273d6016f552e843b5154c-309ee7a02c72.html",
  "6889febab58a71fcc129ac1c": "/6889febab58a71fcc129ac1c-a42bf616b7b0.html",
  "68ef701d42950b539b7c40b5": "/68ef701d42950b539b7c40b5-995f11e114da.html",
  "694bcf96a600611cdb08c3a2": "/694bcf96a600611cdb08c3a2-244f13ce1827.html",
  "699eb28720f540073a45a111": "/699eb28720f540073a45a111-5ad0ddcea018.html",
  "69afd3f598e86c1ebb1a8c75": "/69afd3f598e86c1ebb1a8c75-916f88391aee.html",
  "69e8affa3f5ac655e8557c36": "/69e8affa3f5ac655e8557c36-6fe6fb8d8e07.html",
  "66334529937d97accbf16a85": "/66334529937d97accbf16a85-4aa2c6702f4e.html",
  "668e67310f1aafc87706b7d0": "/668e67310f1aafc87706b7d0-e7949a036804.html",
  "67f6eb9516f552e843af42cf": "/67f6eb9516f552e843af42cf-5c4d12a04251.html",
  "68d2bda07dc09467031ac066": "/68d2bda07dc09467031ac066-8ffb24507485.html",
  "6644c147937d97accbf26d7a": "/6644c147937d97accbf26d7a-cf8b1905d757.html",
  "6824520516f552e843b40bfa": "/6824520516f552e843b40bfa-4f8b61922441.html",
  "66f168970255a9f8088f2152": "/66f168970255a9f8088f2152-d292d6c64eb2.html",
  "66fea3990255a9f80892a213": "/66fea3990255a9f80892a213-a19bb4160454.html",
  "673dd36992e99634ba8d56f9": "/673dd36992e99634ba8d56f9-0b55a40f2c29.html",
  "673f907e92e99634ba8f7994": "/673f907e92e99634ba8f7994-73c9228e247d.html",
  "67448825c1b59287554cdeaa": "/67448825c1b59287554cdeaa-624cd13ef37e.html",
  "67def4a677b36b5408696a9c": "/67def4a677b36b5408696a9c-0b1a49596b29.html",
  "682c950b01e210fd5ba8be14": "/682c950b01e210fd5ba8be14-28d37f37a10c.html",
  "67603ff392e99634ba91ed64": "/67603ff392e99634ba91ed64-cdf7249ab72a.html",
  "6762e1e992e99634ba92f35e": "/6762e1e992e99634ba92f35e-6e32605b13a3.html",
  "679923a916f552e843a14499": "/679923a916f552e843a14499-249b8646ca1b.html",
  "67a9e422c1b59287554ffcc2": "/67a9e422c1b59287554ffcc2-9e9e4606d15f.html",
  "67c1b5bcc61b8ffa997ac2fa": "/67c1b5bcc61b8ffa997ac2fa-dc946b077dec.html",
  "67c99064603fc771f7be94c1": "/67c99064603fc771f7be94c1-cfb4ee2ad28a.html",
  "67f63c8516f552e843aef7d0": "/67f63c8516f552e843aef7d0-25d001a0995c.html",
  "680b410b77b36b54086bd226": "/680b410b77b36b54086bd226-46afcfbc01d2.html",
  "6822e7a9217e44c32fe54164": "/6822e7a9217e44c32fe54164-6acee2a7f9bc.html",
  "68de25601dff1103faea015f": "/68de25601dff1103faea015f-6f34d5f338aa.html",
  "68ee539d9fdc569d6bbd213d": "/68ee539d9fdc569d6bbd213d-5555ae3e1c81.html",
  "68148d8816f552e843b09e0b": "/68148d8816f552e843b09e0b-5bb3ebd8e1f3.html",
  "68149b56f8781281fbdebbe8": "/68149b56f8781281fbdebbe8-d0e8f196772b.html",
  "682f156db2e891706cca5c8d": "/682f156db2e891706cca5c8d-49a1b3f4d71e.html",
  "6852bf7b01e210fd5baaef07": "/6852bf7b01e210fd5baaef07-a00d077c695e.html",
  "685513fb934c54b913ec622d": "/685513fb934c54b913ec622d-3726fc6641f5.html",
  "6870d741ffe7d0a0c6cf9c04": "/6870d741ffe7d0a0c6cf9c04-d612688079ec.html",
  "68e90dc63aaefa5a41c2c56c": "/68e90dc63aaefa5a41c2c56c-c8d648d8c0ff.html",
  "68711d90dd966bd6acd61d95": "/68711d90dd966bd6acd61d95-01a572033bef.html",
  "689dc1ebb58a71fcc12c1e28": "/689dc1ebb58a71fcc12c1e28-c051e93d299a.html",
  "6925645a60ce410ab5d2ca48": "/6925645a60ce410ab5d2ca48-e5ad51cb6ec9.html",
  "69675e39e4e59712b499f9da": "/69675e39e4e59712b499f9da-7582a22f2027.html",
  "6a3ce4c1f83abc415ef2a335": "/6a3ce4c1f83abc415ef2a335-65998d81876b.html",
  "6aa7b0b60a0e6d227a1cb538": "/6aa7b0b60a0e6d227a1cb538-8aca34e6b736.html",
  "689dede3b58a71fcc12ca466": "/689dede3b58a71fcc12ca466-e76af77993b5.html",
  "68ad629f1f962e55b79ef493": "/68ad629f1f962e55b79ef493-d47679f8847c.html",
  "68bebf7d01091b28ab4bc64e": "/68bebf7d01091b28ab4bc64e-218905073988.html",
  "69fb56e585e44162352eba45": "/69fb56e585e44162352eba45-25ff1af96172.html",
  "68c8472c6e565bd173d48412": "/68c8472c6e565bd173d48412-635a3e60e494.html",
  "68e6127cba0e9ba0b83aae6d": "/68e6127cba0e9ba0b83aae6d-bf4b991e8679.html",
  "68f60fdfca5b335d7d410a42": "/68f60fdfca5b335d7d410a42-d13f54d5523e.html",
  "690c5ef06f2578e5730a3f72": "/690c5ef06f2578e5730a3f72-a816eb26148a.html",
  "69285de0afc190dd642d5d82": "/69285de0afc190dd642d5d82-9ee9b41a1dfc.html",
  "695f63443098588ae66c46f7": "/695f63443098588ae66c46f7-7c634c893b18.html",
  "69685e96a1029e3d2160184d": "/69685e96a1029e3d2160184d-a91dda96e9dc.html",
  "6968d0b6c2dc43603732e8fa": "/6968d0b6c2dc43603732e8fa-5ec10d5d5b88.html",
  "6971f7da01c944cc7b14b1b7": "/6971f7da01c944cc7b14b1b7-8bfb531a0d0f.html",
  "699c4dfd5ecc58dcbb97adb5": "/699c4dfd5ecc58dcbb97adb5-606861c40692.html",
  "6a5e0911b7b9c93b24824240": "/6a5e0911b7b9c93b24824240-0efd4fc2ee4f.html",
  "6a7dc4c1bfdc0ce74c041dbd": "/6a7dc4c1bfdc0ce74c041dbd-0efd4fc2ee4f.html",
  "69a180e90e3b5a25fd6fc228": "/69a180e90e3b5a25fd6fc228-96197f2ea124.html",
  "69c628dbb830ec33f33d38d9": "/69c628dbb830ec33f33d38d9-03ea090ec454.html",
  "69ca1b65a753c74efe604ba4": "/69ca1b65a753c74efe604ba4-ce7f9fa96296.html",
  "69ddef00bbde9ac0cef06a9d": "/69ddef00bbde9ac0cef06a9d-7f3e88a34c1c.html",
  "6a69a29242abf630309a9b75": "/6a69a29242abf630309a9b75-6e2d4b9c2de0.html",
  "6a6b58c3adef5f63048571fc": "/6a6b58c3adef5f63048571fc-de3f03ca5e43.html",
  "6a8846e60b2d421350da777b": "/6a8846e60b2d421350da777b-506922b0e467.html",
  "6a9eb5617bf58dc206580e51": "/6a9eb5617bf58dc206580e51-c59a526fded6.html",
  "6aa3fa99a84d1175ff3ebc16": "/6aa3fa99a84d1175ff3ebc16-cafdc4440a73.html",
  "6aad2aab36f8d84e243be73b": "/6aad2aab36f8d84e243be73b-f13b469f8b61.html",
  "6ab5208b6812939a39c3410e": "/6ab5208b6812939a39c3410e-493c6b9917ef.html",
  "6ac4fbcf098f4e70a82aed10": "/6ac4fbcf098f4e70a82aed10-d006f62c9283.html"
};

export const gameImages = {
  "699c4e0d487902dd93c9c77d": img_145,
  "5f5b691eb75dc0c7b89b2492": img_146,
  "601a6443b3e245291110ac7a": img_147,
  "603ce43ea91fee82f50334d3": img_148,
  "605cc7b259a203d77244525c": img_149,
  "6079680d222d9801f96bab74": img_150,
  "614081de93ddb73076a1538a": img_151,
  "619e14fb68af90fbc06a4345": img_152,
  "61af33d3222f4485886da806": img_153,
  "61fd1d864e862442e1bd67db": img_154,
  "62581d4558d6dd7853a161e8": img_155,
  "625e7d9c152625add904a679": img_156,
  "6266a66a152625add904bce8": img_157,
  "6267bb9ee12f014cd14b6c9f": img_158,
  "627baaf241f6066717ff413f": img_159,
  "62864cd341f6066717ff801e": img_160,
  "629e01961f70c95b7fd67b3a": img_161,
  "62a09e2041f6066717fff686": img_162,
  "62b9a830cc0ad8e0a9eaa81c": img_163,
  "62e8c71357d6958461cbe9d6": img_164,
  "62f50cd857d6958461cc54d3": img_165,
  "62f6121457d6958461cc7ef0": img_166,
  "6318807957d6958461cd5fc1": img_167,
  "632aca17d12f27f917de59ec": img_168,
  "635fe93ded1431b3f7d2215c": img_169,
  "6371ed43dd2735639e05b6ab": img_170,
  "63f8a26aa2afbaeb5f803de3": img_171,
  "63ff24d8f1b9d0fb8487223f": img_172,
  "640060027d19caf1ca799d1f": img_173,
  "649a7061f01fdda7a6d44598": img_174,
  "656f16ee7e3091d6e2607a1d": img_175,
  "65a6576f99010ea68565fb77": img_176,
  "65cb16fc897ec6f9db711354": img_177,
  "65fae6d540aceaef5d88bd51": img_178,
  "661504b840aceaef5d8cba1f": img_179,
  "6615087940aceaef5d8cbace": img_180,
  "6627943e40aceaef5d8eec81": img_181,
  "66333f70937d97accbf169e1": img_182,
  "6644b6a2937d97accbf26c30": img_183,
  "66f168190255a9f8088f2134": img_184,
  "66fea2d30255a9f80892a1ec": img_185,
  "673dd19192e99634ba8d569e": img_186,
  "673f847e92e99634ba8f7826": img_187,
  "6744875ec1b59287554cde94": img_188,
  "67603fb092e99634ba91ed45": img_189,
  "6762dc9292e99634ba92f290": img_190,
  "679922d916f552e843a1446b": img_191,
  "67a9e274c1b59287554ffc88": img_192,
  "67c1a8b6c61b8ffa997aaf24": img_193,
  "67c98f9f603fc771f7be949a": img_194,
  "67f63c4516f552e843aef7b6": img_195,
  "680b3fd577b36b54086bd1f4": img_196,
  "68147c6b16f552e843b09b8f": img_197,
  "681492b0f8781281fbdebab1": img_198,
  "682de1c2225b4401253dfd88": img_199,
  "6852a04101e210fd5baae9a7": img_200,
  "6855138e934c54b913ec620e": img_201,
  "6870126bffe7d0a0c6cf9488": img_202,
  "68711421dd966bd6acd61b2d": img_203,
  "689dc000b58a71fcc12c1dde": img_204,
  "689ded63b58a71fcc12ca44a": img_205,
  "68ad55371f962e55b79ee2ce": img_206,
  "68bebf3101091b28ab4bc634": img_207,
  "68c846e2d41928d12b940cfd": img_208,
  "68f60fd436168a5d713986a1": img_209,
  "690c5e87c9e53de5066d6a07": img_210,
  "69285d21da1771d94d2727a1": img_211,
  "695f63420eb4a48a9e39b942": img_212,
  "69685e6d7bddb93c13921c1a": img_213,
  "6968d0966becd95f675f002b": img_214,
  "6971f7d01b07b8cc2dc7ea9b": img_215,
  "69a1808c8a131a2568e0d27f": img_216,
  "69c628b4bd4b73330eb1f822": img_217,
  "69ca1b2d1555da4e9bb8c13f": img_218,
  "69ddeebba91765c06b00b555": img_219,
  "6a69a26d4021ba2f3181f5f1": img_220,
  "6a6b5429d8e3c251379b214f": img_221
};

export const defaultGameConfigs = {
  "5f5b691eb75dc0c7b89b2493": config_0,
  "601a649cb3e245291110acce": config_1,
  "6103eaf12eae9d3e856d6ec8": config_2,
  "615df9f441e1e0829ab60118": config_3,
  "6397080fa16dbba4ba8df419": config_4,
  "63970bb3a16dbba4ba8df48a": config_5,
  "6613bbb840aceaef5d8ca8fd": config_6,
  "69d4b08d035de1478c5313a6": config_7,
  "603ce698a91fee82f50336fe": config_8,
  "650d4cfef1e29aa6e06d261f": config_9,
  "651a6d1f1bc1b828d545667b": config_10,
  "6530e2601904b92b4fbe379d": config_11,
  "653777541904b92b4fbec721": config_12,
  "664df9c5bb75a0017c85a6aa": config_13,
  "6777f21d92e99634ba954119": config_14,
  "67a103fb16f552e843a45d87": config_15,
  "67b59c4916f552e843a82179": config_16,
  "6818a35816f552e843b1fb97": config_17,
  "688cb722b58a71fcc12a7ada": config_18,
  "68a568a7b58a71fcc12cdcd6": config_19,
  "68bec1dface07b66002a8ea4": config_20,
  "68c966eb2bf654ac1ba732c2": config_21,
  "68f205bff9752f622e2aaf62": config_22,
  "68f9f3f9ac586102dd22f713": config_23,
  "6916ddd43a547fddee788a46": config_24,
  "691efc10f0ad3f159bc35c77": config_25,
  "6936ce56fc02f9d8109d2ae6": config_26,
  "693ac4e55572221276ab43b8": config_27,
  "69dc56d014010a01d60b8a78": config_28,
  "6a2a5369da0eee2da0737d4b": config_29,
  "6a3e8d87be78e15762bd6a64": config_30,
  "605cc8a259a203d772445287": config_31,
  "654b3d221904b92b4fbeeb53": config_32,
  "69a002cef372556bcdea313f": config_33,
  "6a60c472c465a15559854f2d": config_34,
  "60796c54222d9801f96bac5b": config_35,
  "6140893d93ddb73076a1554e": config_36,
  "619e14fb68af90fbc06a4345": config_37,
  "61af33d3222f4485886da806": config_38,
  "623c457358d6dd7853a01a00": config_39,
  "61fd1eb64e862442e1bd6828": config_40,
  "625984d758d6dd7853a1bd9d": config_41,
  "625e7ecf152625add904a6d9": config_42,
  "6266a6fe152625add904bd19": config_43,
  "6267c05ae12f014cd14b6eed": config_44,
  "627babd141f6066717ff417d": config_45,
  "6286500f41f6066717ff80c7": config_46,
  "629e0b671f70c95b7fd67de8": config_47,
  "6450ec1566c580b614f8bb06": config_48,
  "68adabd0b58a71fcc12e2192": config_49,
  "69b7b831238b6de497d7803e": config_50,
  "62a0a15241f6066717fff6ee": config_51,
  "62b9b2a2cc0ad8e0a9eaa9b7": config_52,
  "62e8c9a757d6958461cbea45": config_53,
  "62f50da057d6958461cc550e": config_54,
  "6332e467d12f27f917df1ac0": config_55,
  "66b5fe200f1aafc87731fcb5": config_56,
  "62f612be60e29e02961bbfd6": config_57,
  "6318818257d6958461cd6005": config_58,
  "6461dcd4f01fdda7a6d2769b": config_59,
  "632acab6d12f27f917de5a16": config_60,
  "635fe9eaed1431b3f7d22181": config_61,
  "637345bcdd2735639e05c8b0": config_62,
  "63f8a309a2afbaeb5f803e1f": config_63,
  "63ff2e7ff1b9d0fb84872367": config_64,
  "6527bf7c1904b92b4fbd6721": config_65,
  "64007d1f7d19caf1ca79a27b": config_66,
  "649a90aaf01fdda7a6d44888": config_67,
  "6570216c7e3091d6e2607d91": config_68,
  "69ef52e55b3df618e76de9c9": config_69,
  "65a6644b99010ea68565fd0e": config_70,
  "6879f875b58a71fcc127119f": config_71,
  "65cb1d1d897ec6f9db711418": config_72,
  "65fae73d40aceaef5d88bd70": config_73,
  "6615052f40aceaef5d8cba51": config_74,
  "6615094d40aceaef5d8cbafd": config_75,
  "6627a1da40aceaef5d8eee0d": config_76,
  "68273d6016f552e843b5154c": config_77,
  "6889febab58a71fcc129ac1c": config_78,
  "68ef701d42950b539b7c40b5": config_79,
  "694bcf96a600611cdb08c3a2": config_80,
  "699eb28720f540073a45a111": config_81,
  "69afd3f598e86c1ebb1a8c75": config_82,
  "69e8affa3f5ac655e8557c36": config_83,
  "66334529937d97accbf16a85": config_84,
  "668e67310f1aafc87706b7d0": config_85,
  "67f6eb9516f552e843af42cf": config_86,
  "68d2bda07dc09467031ac066": config_87,
  "6644c147937d97accbf26d7a": config_88,
  "6824520516f552e843b40bfa": config_89,
  "66f168970255a9f8088f2152": config_90,
  "66fea3990255a9f80892a213": config_91,
  "673dd36992e99634ba8d56f9": config_92,
  "673f907e92e99634ba8f7994": config_93,
  "67448825c1b59287554cdeaa": config_94,
  "67def4a677b36b5408696a9c": config_95,
  "682c950b01e210fd5ba8be14": config_96,
  "67603ff392e99634ba91ed64": config_97,
  "6762e1e992e99634ba92f35e": config_98,
  "679923a916f552e843a14499": config_99,
  "67a9e422c1b59287554ffcc2": config_100,
  "67c1b5bcc61b8ffa997ac2fa": config_101,
  "67c99064603fc771f7be94c1": config_102,
  "67f63c8516f552e843aef7d0": config_103,
  "680b410b77b36b54086bd226": config_104,
  "6822e7a9217e44c32fe54164": config_105,
  "68de25601dff1103faea015f": config_106,
  "68ee539d9fdc569d6bbd213d": config_107,
  "68148d8816f552e843b09e0b": config_108,
  "68149b56f8781281fbdebbe8": config_109,
  "682f156db2e891706cca5c8d": config_110,
  "6852bf7b01e210fd5baaef07": config_111,
  "685513fb934c54b913ec622d": config_112,
  "6870d741ffe7d0a0c6cf9c04": config_113,
  "68e90dc63aaefa5a41c2c56c": config_114,
  "68711d90dd966bd6acd61d95": config_115,
  "689dc1ebb58a71fcc12c1e28": config_116,
  "6925645a60ce410ab5d2ca48": config_117,
  "69675e39e4e59712b499f9da": config_118,
  "6a3ce4c1f83abc415ef2a335": config_119,
  "689dede3b58a71fcc12ca466": config_120,
  "68ad629f1f962e55b79ef493": config_121,
  "68bebf7d01091b28ab4bc64e": config_122,
  "69fb56e585e44162352eba45": config_123,
  "68c8472c6e565bd173d48412": config_124,
  "68e6127cba0e9ba0b83aae6d": config_125,
  "68f60fdfca5b335d7d410a42": config_126,
  "690c5ef06f2578e5730a3f72": config_127,
  "69285de0afc190dd642d5d82": config_128,
  "695f63443098588ae66c46f7": config_129,
  "69685e96a1029e3d2160184d": config_130,
  "6968d0b6c2dc43603732e8fa": config_131,
  "6971f7da01c944cc7b14b1b7": config_132,
  "69a180e90e3b5a25fd6fc228": config_133,
  "69c628dbb830ec33f33d38d9": config_134,
  "69ca1b65a753c74efe604ba4": config_135,
  "69ddef00bbde9ac0cef06a9d": config_136,
  "6a69a29242abf630309a9b75": config_137,
  "6a6b58c3adef5f63048571fc": config_138,
  "6a8846e60b2d421350da777b": config_139,
  "6a9eb5617bf58dc206580e51": config_140,
  "6aa3fa99a84d1175ff3ebc16": config_141,
  "6aad2aab36f8d84e243be73b": config_142,
  "6ab5208b6812939a39c3410e": config_143,
  "6ac4fbcf098f4e70a82aed10": config_144
};

export default previewsGenerated;
